// Styles to compile to the frontend
import './style.scss';

// Other Scripts
import './js/scripts.js';
import './js/components/pop-box.js';
